import { render, staticRenderFns } from "./AuthorityChatModal.vue?vue&type=template&id=9f594f4e&scoped=true"
import script from "./AuthorityChatModal.vue?vue&type=script&lang=js"
export * from "./AuthorityChatModal.vue?vue&type=script&lang=js"
import style0 from "./AuthorityChatModal.vue?vue&type=style&index=0&id=9f594f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f594f4e",
  null
  
)

export default component.exports